import React, { FormEvent } from "react";
import MigratedForm from "../../../../components/components/molecules/Form";
import { FormProvider, FormField } from "./FormContext";

interface FormProps {
    action?: string | undefined;
    children: React.ReactNode;
    className?: string;
    errors?: FormField;
    id: string;
    method?: string;
    onChangedValue: (
        inputName: string,
        inputValue: string,
        previousValue: string,
        shouldValidate: boolean,
        isVisible: boolean,
    ) => void;
    onRemoveInput: (inputName: string) => void;
    onSubmit: (e: FormEvent) => void;
    started?: FormField;
    values?: FormField;
    visible?: FormField;
}

const Form: React.FC<FormProps> = ({
    id,
    className,
    action,
    method,
    values = {},
    errors,
    visible = {},
    started = {},
    children,
    onChangedValue,
    onRemoveInput,
    onSubmit,
}) => (
    <FormProvider
        value={{
            values: values || {},
            inputPrefix: "",
            errors: errors || {},
            visible: visible || {},
            started: started || {},
            removeValue: (inputName) => onRemoveInput(inputName),
            setValue: (inputName, inputValue, previousValue, shouldValidate, isVisible) =>
                onChangedValue(inputName, inputValue, previousValue, shouldValidate, isVisible),
        }}
    >
        <MigratedForm action={action} id={id} className={className} method={method} onSubmit={onSubmit}>
            {children}
        </MigratedForm>
    </FormProvider>
);

export default Form;
